/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
import { POST } from '@/api/index'
// export const BASE_URL = "http://test.api.51xiaoping.com/" //测试环境
// export const zpUrl = "http://beta.zp.51xiaoping.com/#/"

export const BASE_URL = "https://api.51xiaoping.com/" //正式环境
export const zpUrl = "http://xspj.51xiaoping.com/#/"

// 登录接口
export function userLogin(params) {
    return POST(`${BASE_URL}/evaluate/user/login`, params, 'post', '', 2)
}

// 登录用户信息
export function loginUserInfo(params) {
    return POST(`${BASE_URL}/evaluate/usercenter/get-info`, params, 'get')
}
// 获取用户菜单
export function getUserMenu(params) {
    return POST(`${BASE_URL}/evaluate/menu/tree-by-user`, params, 'get')
}
// 查看权限菜单
export function getRoleMenu(params) {
    return POST(`${BASE_URL}/evaluate/menu/tree-by-role`, params, 'get')
}

// 用户重置密码
export function resetPwd(params) {
    return POST(`${BASE_URL}/evaluate/usercenter/reset-password`, params, 'get')
}

// 获取区域列表
export function getAreaList(params) {
    return POST(`${BASE_URL}/evaluate/area/list`, params, 'get')
}

// 获取学校列表
export function getSchoolList(params) {
    return POST(`${BASE_URL}/evaluate/school/list`, params, 'get')
}

// 获取学校类型列表
export function getSchoolTypeList(params) {
    return POST(`${BASE_URL}/evaluate/school/getschooltypelist`, params, 'get')
}

// 获取学校应用列表
export function getSchoolAppList(params) {
    return POST(`${BASE_URL}/evaluate/school/application/list`, params, 'get')
}

// 获取学校详情
export function getSchoolInfo(params) {
    return POST(`${BASE_URL}/evaluate/school/get-info`, params, 'get')
}

// 获取集团校列表
export function getGroupList(params) {
    return POST(`${BASE_URL}/evaluate/school/group/list`, params, 'get')
}

// 获取所在单位
export function getOrgList(params) {
    return POST(`${BASE_URL}/evaluate/org/list`, params, 'get')
}

// 获取模板列表
export function getTempList(params) {
    return POST(`${BASE_URL}/evaluate/template/list`, params, 'get')
}

// 添加编辑学校
export function saveSchool(params) {
    return POST(`${BASE_URL}/evaluate/school`, params)
}

// 获取学科列表
export function getSubjectList(params) {
    return POST(`${BASE_URL}/evaluate/subject/list`, params, 'get')
}

// 获取年级列表
export function getGradeList(params) {
    return POST(`${BASE_URL}/evaluate/grade/gradelist`, params, 'get')
}

// 获取优课类型列表
export function getCourseTypeList(params) {
    return POST(`${BASE_URL}/evaluate/course/coursetype/list`, params, 'get')
}

// 获取优课列表
export function getCourseList(params) {
    return POST(`${BASE_URL}/evaluate/course/list`, params, 'get')
}

// 获取名师列表
export function getTeacherList(params) {
    return POST(`${BASE_URL}/evaluate/teacher/list`, params, 'get')
}

// 获取教材列表
export function getBookList(params) {
    return POST(`${BASE_URL}/evaluate/book/list`, params, 'get')
}

// 获取教材章节树
export function getBookTreeList(params) {
    return POST(`${BASE_URL}/evaluate/book/getchaptertree`, params, 'get')
}

// 获取上传资源类型
export function getResTypeList(params) {
    return POST(`${BASE_URL}/evaluate/res/types/list`, params, 'get')
}

//上传图片
export function uploadImage(params) {
    return POST(`${BASE_URL}/evaluate/file/oss-upload`, params)
}
export function ossupload(params) {
    return `${BASE_URL}/evaluate/file/oss-upload`
}
export const ossuploads = `${BASE_URL}/evaluate/file/oss-upload`
// 获取课程详情
export function getCourseInfo(params) {
    return POST(`${BASE_URL}/evaluate/course/` + params.id, {}, 'get')
}

//新增或编辑课程信息
export function saveCourse(params) {
    return POST(`${BASE_URL}/evaluate/course`, params)
}

//新增或编辑课时
export function saveCourseLesson(params) {
    return POST(`${BASE_URL}/evaluate/course/lesson`, params)
}

//上传附件
export function uploadFile(params) {
    return POST(`${BASE_URL}/evaluate/file/file-upload`, params)
}

// 删除课程
export function deleteCourse(params) {
    return POST(`${BASE_URL}/evaluate/course/` + params.id, {}, 'delete')
}
// 删除课时
export function deleteLesson(params) {
    return POST(`${BASE_URL}/evaluate/course/lesson/` + params.id, {}, 'delete')
}
// 专题资源-按父级ID获取分类列表
export function matictypeslist(params) {
    return POST(`${BASE_URL}/evaluate/matic/types/list`, params, 'get')
}
// 专题资源-查看资源列表
export function maticlist(params) {
    return POST(`${BASE_URL}/evaluate/matic/list`, params, 'get')
}
// 专题资源-教师列表
export function teacherlist(params) {
    return POST(`${BASE_URL}/evaluate/teacher/list`, params, 'get')
}
//专题资源-新增/编辑 资源
export function matic(params) {
    return POST(`${BASE_URL}/evaluate/matic`, params, 'post', '')
}
//专题资源-新增/编辑 分类
export function matictypes(params) {
    return POST(`${BASE_URL}/evaluate/matic/types`, params, 'post', '')
}
//专题资源-删除分类
export function matictypesid(params) {
    return POST(`${BASE_URL}/evaluate/matic/types/` + params.id, {}, 'delete', '')
}
//专题资源-获取资源详情
export function maticid(params) {
    return POST(`${BASE_URL}/evaluate/matic/` + params.id, {}, 'get', '')
}
//专题资源-删除资源
export function DELETEmatic(params) {
    return POST(`${BASE_URL}/evaluate/matic/` + params.id, {}, 'delete', '')
}
//评价模板-获取模板列表
export function TemplateList(params) {
    return POST(`${BASE_URL}/evaluate/template/list`, params, 'get', '')
}
//评价模板-获取模板详情
export function TemplateId(params) {
    return POST(`${BASE_URL}/evaluate/template/` + params.id, {}, 'get', '')
}
//评价模板-新增/修改模板
export function Template(params) {
    return POST(`${BASE_URL}/evaluate/template`, params, 'post', '')
}
//评价模板-获取使用学校列表
export function TemplateSchoolList(params) {
    return POST(`${BASE_URL}/evaluate/template/school/list`, params, 'get', '')
}
//获取机构下学校列表
export function OrgSlist(params) {
    return POST(`${BASE_URL}/evaluate/org/s-list`, params, 'get', '')
}
//教材-获取教材版本列表
export function CourVersionList(params) {
    return POST(`${BASE_URL}/evaluate/course/version/list`, params, 'get', '')
}
//教材-获取（年级）册别列表
export function CourVolumeList(params) {
    return POST(`${BASE_URL}/evaluate/course/volume/list`, params, 'get', '')
}
//新增/编辑 教材
export function Book(params) {
    return POST(`${BASE_URL}/evaluate/book`, params, 'post', '')
}
//获取一本教材树(含章节)
export function BookGetbooktree(params) {
    return POST(`${BASE_URL}/evaluate/book/getbooktree`, params, 'get', '')
}
//获取章节model
export function Bookchapterget(params) {
    return POST(`${BASE_URL}/evaluate/book/chapter/get-one`, params, 'get', '')
}
//新增/编辑 章节
export function BookChapter(params) {
    return POST(`${BASE_URL}/evaluate/book/chapter`, params, 'post', '')
}
//删除 章节
export function Bookchpaterremove(params) {
    return POST(`${BASE_URL}/evaluate/book/chpater/remove`, params, 'post', '', 2)
}
//评价模板-保存区域设置
export function TemplateSchool(params) {
    return POST(`${BASE_URL}/evaluate/template/school`, params, 'post', '')
}
//评价模板-获取指标列表
export function TemplategetFirstLevelNodes(params) {
    return POST(`${BASE_URL}/evaluate/template/getFirstLevelNodes`, params, 'get', '')
}
//数据模型-分页获取模型列表
export function ModelList(params) {
    return POST(`${BASE_URL}/evaluate/model/list`, params, 'get', '')
}
//数据模型-获取所评价规则
export function ModelRulesList(params) {
    return POST(`${BASE_URL}/evaluate/model/rules/list`, params, 'get', '')
}
//数据模型-获取所有转换方式
export function ModelConversionList(params) {
    return POST(`${BASE_URL}/evaluate/model/conversion/list`, params, 'get', '')
}
//评价模板-根据模板ID获取评价指标树
export function TemplateNodesModel(params) {
    return POST(`${BASE_URL}/evaluate/template/nodes/model-list`, params, 'get', '')
}
//组件-获取组件列表
export function ComponentList(params) {
    return POST(`${BASE_URL}/evaluate/component/list`, params, 'get', '')
}
//数据模型-新增/修改
export function Model(params) {
    return POST(`${BASE_URL}/evaluate/model`, params, 'post', '')
}
//组件-获取组件列表（分类）
export function ComponentVoList(params) {
    return POST(`${BASE_URL}/evaluate/component/vo-list`, params, 'get', '')
}
//数据模型-详情
export function ModelId(params) {
    return POST(`${BASE_URL}/evaluate/model/` + params.id, params, 'get', '')
}
//教材-获取所有（年级）册别列表
export function BookVolumeList(params) {
    return POST(`${BASE_URL}/evaluate/book/volume/list`, params, 'get', '')
}
//教材-获取所有教材版本列表
export function BookVersionList(params) {
    return POST(`${BASE_URL}/evaluate/book/version/list`, params, 'get', '')
}
//组件-获取组件元素列表
export function ComponentDetailList(params) {
    return POST(`${BASE_URL}/evaluate/component/detail/list`, params, 'get', '')
}
//组件-新增/修改
export function Component(params) {
    return POST(`${BASE_URL}/evaluate/component`, params, 'post', '')
}
//组件-获取元素详情
export function ComponentDetailId(params) {
    return POST(`${BASE_URL}/evaluate/component/detail/` + params.id, {}, 'get', '')
}
//组件-元素新增/修改
export function ComponentDetail(params) {
    return POST(`${BASE_URL}/evaluate/component/detail`, params, 'post', '')
}
//组件-删除元素
export function ComponentDetaildelete(params) {
    return POST(`${BASE_URL}/evaluate/component/detail/` + params.id, {}, 'delete', '')
}
//指标新增/修改
export function Nodes(params) {
    return POST(`${BASE_URL}/evaluate/nodes`, params, 'post', '')
}
//第三方应用
export function AppEva(params) {
    return POST(`${BASE_URL}/evaluate/app/eva-list`, params, 'get', '')
}
//评价阶段—根据模板ID获取评价阶段时间轴
export function stagetemptimeline(params) {
    return POST(`${BASE_URL}/evaluate/stage/temp-time-line`, params, 'get', '')
}
//评价指标-获取所有评价主体
export function NodesRolesList(params) {
    return POST(`${BASE_URL}/evaluate/nodes/roles/list`, params, 'get', '')
}
//评价指标-数据源新增
export function NodesSources(params) {
    return POST(`${BASE_URL}/evaluate/nodes/sources`, params, 'post', '')
}
//评价指标-删除指标
export function NodesIdShan(params) {
    return POST(`${BASE_URL}/evaluate/nodes/` + params.id, {}, 'delete', '')
}
//评价指标-删除指标
export function NodesSourcesIdShan(params) {
    return POST(`${BASE_URL}/evaluate/nodes/sources/` + params.id, {}, 'delete', '')
}
//评价阶段—保存评价阶段设置
export function Stage(params) {
    return POST(`${BASE_URL}/evaluate/stage`, params, 'post', '')
}
//评价模板-根据模板ID获取应用审核设置结果
export function TemplAteauditSetlist(params) {
    return POST(`${BASE_URL}/evaluate/template/audit/set-list`, params, 'get', '')
}
//评价模板-应用审核设置
export function TemplateAudit(params) {
    return POST(`${BASE_URL}/evaluate/template/audit`, params, 'post', '')
}
//评价模板-获取所有综合评定形式
export function TemplRuleslist(params) {
    return POST(`${BASE_URL}/evaluate/template/rules/list`, params, 'get', '')
}
//评价模板-保存综合评定设置
export function TemplateRules(params) {
    return POST(`${BASE_URL}/evaluate/template/rules`, params, 'post', '')
}
//评价模板-根据模板ID获取综合评定设置
export function TemplRulesId(params) {
    return POST(`${BASE_URL}/evaluate/template/rules/` + params.id, {}, 'get', '')
}
//评价模板-根据模板ID获取综合评定设置
export function componentgetControls(params) {
    return POST(`${BASE_URL}/evaluate/component/getControls`, params, 'get', '')
}
//主题列表
export function themedetaillist(params) {
    return POST(`${BASE_URL}/evaluate/theme/detail/list`, params, 'get', '')
}
//添加列表
export function themedetailsave(params) {
    return POST(`${BASE_URL}/evaluate/theme/detail/save`, params, 'post', '')
}
//GET /theme/list
export function themelist(params) {
    return POST(`${BASE_URL}/evaluate/theme/list`, params, 'get', '')
}
//POST /theme/save
export function themesave(params) {
    return POST(`${BASE_URL}/evaluate/theme/save`, params, 'post', '')
}
//GET /theme/del
export function themedel(params) {
    return POST(`${BASE_URL}/evaluate/theme/del`, params, 'get', '')
}
//
export function nodesgetlist(params) {
    return POST(`${BASE_URL}/evaluate/nodes/get-list`, params, 'get', '')
}
//POST /theme/tmp/save
export function themetmpsave(params) {
    return POST(`${BASE_URL}/evaluate/theme/tmp/save`, params, 'post', '')
}
//POST /points
export function points(params) {
    return POST(`${BASE_URL}/evaluate/points`, params, 'post', '')
}
//GET /template/app/s-list
export function templateapplist(params) {
    return POST(`${BASE_URL}/evaluate/template/app/s-list`, params, 'get', '')
}
//字典
export function dictcode(params) {
    return POST(`${BASE_URL}/evaluate/dict/code`, params, 'get', '')
}
//二维码-获取二维码生成批次记录
export function qrcodegrouplist(params) {
    return POST(`${BASE_URL}/evaluate/qrcode/group/list`, params, 'get', '')
}
//二维码-新增批次
export function qrcode(params) {
    return POST(`${BASE_URL}/evaluate/qrcode`, params, 'post', '')
}
//POST /qrcode/set-status
export function qrcodesetstatus(params) {
    return POST(`${BASE_URL}/evaluate/qrcode/set-status`, params, 'post', '', 2)
}
//获取班级列表
export function classessimplelist(params) {
    return POST(`${BASE_URL}/evaluate/classes/simple/list`, params, 'get', '')
}
//任务创建
export function inittaskcreate(params) {
    return POST(`${BASE_URL}/evaluate/init/task/create`, params, 'post', '')
}
//任务列表
export function inittasklist(params) {
    return POST(`${BASE_URL}/evaluate/init/task/list`, params, 'get', '')
}
//任务班级列表
export function inittaskclasslist(params) {
    return POST(`${BASE_URL}/evaluate/init/task/class/list`, params, 'get', '')
}
//任务详情
export function inittaskdetail(params) {
    return POST(`${BASE_URL}/evaluate/init/task/detail`, params, 'get', '')
}
//学校导出行为
export function pointsexport(params) {
    return POST(`${BASE_URL}/evaluate/points/export`, params, 'get', '')
}
//一键导入教材
export const evaluatebookimportBook = `${BASE_URL}/evaluate/book/importBook`
//好习惯-获取学校的好习惯列表
export function habitschool(params) {
    return POST(`${BASE_URL}/evaluate/habit/school/list`, params, 'get', '')
}
//角色列表
export function rolelist(params) {
    return POST(`${BASE_URL}/evaluate/role/list`, params, 'get', '')
}
//好习惯-添加/修改学校好习惯模板
export function habit(params) {
    return POST(`${BASE_URL}/evaluate/habit`, params, 'post', '')
}
//好习惯-模板删除接口
export function habitid(params) {
    return POST(`${BASE_URL}/evaluate/habit/` + params.id, '', 'DELETE', '')
}
//大爱杯-查询赛事
export function matchqueryMatchInfoList(params) {
    return POST(`${BASE_URL}/evaluate/match/queryMatchInfoList`, params, 'get', '')
}
//获取集团校列表
export function schoolgrouplist(params) {
    return POST(`${BASE_URL}/evaluate/school/group/list`, params, 'get', '')
}
//赛事模板管理列表
export function matchtemplatelist(params) {
    return POST(`${BASE_URL}/evaluate/match/template/list`, params, 'get', '')
}
//赛事模板管理保存
export function matchtemplatesave(params) {
    return POST(`${BASE_URL}/evaluate/match/template/save`, params, 'post', '')
}
//评分标准列表
export function matchitemlist(params) {
    return POST(`${BASE_URL}/evaluate/match/item/list`, params, 'get', '')
}
//评分标准保存
export function matchitemsave(params) {
    return POST(`${BASE_URL}/evaluate/match/item/save`, params, 'post', '')
}
//评分标准删除
export function matchitemdel(params) {
    return POST(`${BASE_URL}/evaluate/match/item/del/` + params.id, '', 'DELETE', '')
}
//赛事评分标准删除
export function matchtemplatedel(params) {
    return POST(`${BASE_URL}/evaluate/match/template/del/` + params.id, '', 'DELETE', '')
}
//大爱杯-新增赛事
export function matchinsertMatch(params) {
    return POST(`${BASE_URL}/evaluate/match/insertMatch`, params, 'post', '')
}
//大爱杯-查询赛事公告
export function matchqueryMatchNotice(params) {
    return POST(`${BASE_URL}/evaluate/match/queryMatchNotice`, params, 'get', '')
}
//大爱杯-保存赛事公告
export function matchsaveMatchNotice(params) {
    return POST(`${BASE_URL}/evaluate/match/saveMatchNotice`, params, 'post', '')
}
//大爱杯-删除赛事公告
export function matchdelMatchNotice(params) {
    return POST(`${BASE_URL}/evaluate/match/delMatchNotice/?id=` + params.id, '', 'post', '')
}
//大爱杯-查询评审小组信息
export function matchselectMatchReviewTeam(params) {
    return POST(`${BASE_URL}/evaluate/match/selectMatchReviewTeam`, params, 'get', '')
}
//大爱杯-保存评审小组
export function matchsaveMatchReviewTeam(params) {
    return POST(`${BASE_URL}/evaluate/match/saveMatchReviewTeam`, params, 'post', '')
}
//大爱杯-删除评审小组
export function matchdelMatchReviewTeam(params) {
    return POST(`${BASE_URL}/evaluate/match/delMatchReviewTeam?id=` + params.id, '', 'post', '')
}
//参数作品-分页查询参数作品
export function matchWorksselectMatchWorks(params) {
    return POST(`${BASE_URL}/evaluate/matchWorks/selectMatchWorks`, params, 'get', '')
}
//参赛作品--初赛进入决赛
export function matchWorkstoFinals(params) {
    return POST(`${BASE_URL}/evaluate/matchWorks/toFinals?matchWorksId=` + params.matchWorksId, '', 'post', '')
}
//参赛作品--结果授予
export function matchWorksawardsResult(params) {
    return POST(`${BASE_URL}/evaluate/matchWorks/awardsResult?matchWorksId=` + params.matchWorksId + '&evaluationResult=' + params.evaluationResult, '', 'post', '')
}
//参赛作品--导出活动结果
// export function matchWorksexportMatchWorks(params) {
// 	return POST(`${BASE_URL}/evaluate/matchWorks/exportMatchWorks`,params,'get','')
// }
//参赛作品--决赛上传作品
export function matchWorkssetMatchWorks(params) {
    return POST(`${BASE_URL}/evaluate/matchWorks/setMatchWorks`, params, 'post', '')
}
//活动结果--决赛作品--作品得分详情
export function matchassessworksScoreDetails(params) {
    return POST(`${BASE_URL}/evaluate/match/assess/worksScoreDetails`, params, 'get', '')
}
//大爱杯-发布赛事
export function matchupdateMatchStatus(params) {
    return POST(`${BASE_URL}/evaluate/match/updateMatchStatus?id=` + params.id, '', 'post', '')
}
//大爱杯-公布赛事结果
export function matchupdateMatchResult(params) {
    return POST(`${BASE_URL}/evaluate/match/updateMatchResult?id=` + params.id, '', 'post', '')
}
export function matchassessresultexport() {
    return `${BASE_URL}/evaluate/match/assess/result/export`
}
export function matchWorksexportMatchWorks() {
    return `${BASE_URL}/evaluate/matchWorks/exportMatchWorks`
}
//课程详情-根据课时ID获取推流地址
export function lessongetPushUrl(params) {
    return POST(`${BASE_URL}/evaluate/lesson/getPushUrl`, params, 'get', '')
}
//获取学校管理课程列表
export function curriculumManagelist(params) {
    return POST(`${BASE_URL}/evaluate/curriculumManage/list`, params, 'get', '')
}
//保存课程行为
export function curriculumManagesaveCoursePoints(params) {
    return POST(`${BASE_URL}/evaluate/curriculumManage/saveCoursePoints`, params, 'post', '')
}
//保存卡面图
export function curriculumManagesaveCardImage(params) {
    return POST(`${BASE_URL}/evaluate/curriculumManage/saveCardImage`, params, 'post', '', 2)
}
//导出课程行为
export const curriculumManagecoursePointexport = `${BASE_URL}/evaluate/curriculumManage/coursePoint/export`
//导入课程行为
export const curriculumport = `${BASE_URL}/evaluate/curriculumManage/coursePoint/import`
//下载课程行为导入模板
export const curriculumManagedownloadtemplate = `${BASE_URL}/evaluate/curriculumManage/download/template`
//学校课程--课程卡导出
export const schoolCoursecardexport = `${BASE_URL}/evaluate/schoolCourse/card/export`
////////////////  听评课  /////////////
// 查询录课信息
export function selectEvaCourseVideotape(params) {
    return POST(`${BASE_URL}/evaluate/videotape/selectEvaCourseVideotape`, params, 'get', '')
}
// 查询评课专家
export function selectExpertList(params) {
    return POST(`${BASE_URL}/evaluate/videotape/selectExpertList`, params, 'get', '')
}
//听评课--分配专家
export function expertAssignVideotape(params) {
    return POST(`${BASE_URL}/evaluate/videotape/expertAssignVideotape`, params, 'post', '',)
}
//导出听评课情况
// export function exportEvaCourseVideotape(params) {
// 	return POST(`${BASE_URL}/evaluate/videotape/exportEvaCourseVideotape`,params,'get','',)
// }
export const exportEvaCourseVideotape = `${BASE_URL}/evaluate/videotape/exportEvaCourseVideotape`


// 根据录课主键ID查询录课信息
export function selectByPrimaryKey(params) {
    return POST(`${BASE_URL}/evaluate/videotape/selectByPrimaryKey`, params, 'get', '')
}
// 删除该角色的专家角色（专用）
export function deleteRole(params) {
    return POST(`${BASE_URL}/evaluate/role/user?roleType=teacher&userId=` + params.userId + `&roleId=-1008`, '', 'DELETE', '')
}
// 为角色增加用户,为用户分配角色
export function addRole(params) {
    return POST(`${BASE_URL}/evaluate/role/user?roleType=teacher&userIds=` + params.userIds + `&roleId=-1008`, '', 'post', '',)
}
//根据MD5值获取专家附件资源
export function getExpertFile(params) {
    return POST(`${BASE_URL}/evaluate/videotape/getExpertFile`, params, 'get', '')
}
//报告单主题列表
export function reportthemelist(params) {
    return POST(`${BASE_URL}/evaluate/report/theme/list`, params, 'get', '')
}
//报告单主题修改添加
export function reportthemesave(params) {
    return POST(`${BASE_URL}/evaluate/report/theme/save`, params, 'post', '')
}
//学校纪实报告列表
export function reportthemegetShoolThemeList(params) {
    return POST(`${BASE_URL}/evaluate/report/theme/getShoolThemeList`, params, 'get', '')
}
//纪实报告修改添加
export function reportthemesaveSchoolTheme(params) {
    return POST(`${BASE_URL}/evaluate/report/theme/saveSchoolTheme`, params, 'post', '')
}
//学校成长档案主题-删除主题
export function reportthemesavethemeschoolTheme(params) {
    return POST(`${BASE_URL}/evaluate/report/theme/schoolTheme/` + params.id, '', 'delete', '')
}

// 帮助中心 //

// 分页查询问题分类信息
export function selectProblemType(params) {
    return POST(`${BASE_URL}/evaluate/problem/selectProblemType`, params, 'get', '')
}
// 查询问题分类信息
export function selectByPrimaryKeys(params) {
    return POST(`${BASE_URL}/evaluate/problem/selectByPrimaryKey/` + params, '', 'get', '')
}
// 保存问题分类
export function saveProblemType(params) {
    return POST(`${BASE_URL}/evaluate/problem/saveProblemType`, params, 'post', '',)
}
// 删除问题分类
export function deleteByPrimaryKey(params) {
    return POST(`${BASE_URL}/evaluate/problem/deleteByPrimaryKey/` + params, '', 'DELETE', '')
}

// 分页查询问题信息
export function selectProblem(params) {
    return POST(`${BASE_URL}/evaluate/problem/selectProblem`, params, 'get', '')
}
// 保存问题
export function saveProblem(params) {
    return POST(`${BASE_URL}/evaluate/problem/saveProblem`, params, 'post', '',)
}
// 删除问题
export function deleteByPrimaryKeys(params) {
    return POST(`${BASE_URL}/evaluate/problem/deleteProblemByPrimaryKey/` + params, '', 'DELETE', '')
}
// 根据问题主键ID查询问题信息
export function selectProblemByPrimaryKey(params) {
    return POST(`${BASE_URL}/evaluate/problem/selectProblemByPrimaryKey/` + params, '', 'get', '')
}
// 分页查询意见反馈信息
export function selectFeedback(params) {
    return POST(`${BASE_URL}/evaluate/problem/selectFeedback`, params, 'get', '')
}
//获取历史学期
export function yearhistorylist() {
    return POST(`${BASE_URL}/evaluate/year/get-history-list`, '', 'get', '')
}
//列表
export function reportformtask(params) {
    return POST(`${BASE_URL}/evaluate/report/form/task/list`, params, 'get', '')
}
//样态新增编辑
export function themepatternsave(params) {
    return POST(`${BASE_URL}/evaluate/theme/pattern/save`, params, 'post', '')
}
//样态列表
export function themepatternlist(params) {
    return POST(`${BASE_URL}/evaluate/theme/pattern/list`, params, 'get', '')
}
//综评设置-进阶等级设置
export function settingappletranksadd(params) {
    return POST(`${BASE_URL}/evaluate/setting/applet/ranks/add`, params, 'get', '')
}
//综评设置-进阶等级保存
export function settingappletrankssave(params) {
    return POST(`${BASE_URL}/evaluate/setting/applet/ranks/save`, params, 'post', '')
}
//综评设置-进阶等级删除
export function settingappletranksdel(params) {
    return POST(`${BASE_URL}/evaluate/setting/applet/ranks/del`, params, 'get', '')
}
//机构课程--查询机构课程类型
export function mechanismselectEvaCourseType() {
    return POST(`${BASE_URL}/evaluate/mechanism/selectEvaCourseType`, '', 'get', '')
}
//勋章列表
export function medallist(params) {
    return POST(`${BASE_URL}/evaluate/medal/list`, params, 'get', '')
}
//勋章类型查询
export function medaltypes() {
    return POST(`${BASE_URL}/evaluate/medal/types`, '', 'get', '')
}
//勋章保存
export function medalsave(params) {
    return POST(`${BASE_URL}/evaluate/medal/save`, params, 'post', '')
}
//勋章删除
export function medaldel(params) {
    return POST(`${BASE_URL}/evaluate/medal/del/` + params.id, params, 'DELETE', '')
}
//根据应用ID获取小程序列表
export function appgetMpList(params) {
    return POST(`${BASE_URL}/evaluate/app/getMpList`, params, 'get', '')
}
//应用管理--分页查询应用信息
export function appselectPageList(params) {
    return POST(`${BASE_URL}/evaluate/app/selectPageList`, params, 'get', '')
}
//应用管理--查询应用分类信息
export function appselectList(params) {
    return POST(`${BASE_URL}/evaluate/app/selectList`, params, 'get', '')
}
//应用管理--保存应用
export function appsaveApplication(params) {
    return POST(`${BASE_URL}/evaluate/app/saveApplication`, params, 'post', '')
}
//菜单管理--查询应用下的菜单
export function menugetMenuByAppId(params) {
    return POST(`${BASE_URL}/evaluate/menu/getMenuByAppId`, params, 'get', '')
}
//新增/修改菜单
export function menu(params) {
    return POST(`${BASE_URL}/evaluate/menu`, params, 'post', '')
}
//菜单管理--查询角色对应的应用信息菜单
export function menuqueryApplicatinoMenuTreeByRoleId(params) {
    return POST(`${BASE_URL}/evaluate/menu/queryApplicatinoMenuTreeByRoleId/` + params.roleId, '', 'get', '')
}
//角色管理--分配权限
export function roleassignPermissions(params) {
    return POST(`${BASE_URL}/evaluate/role/assignPermissions`, params, 'post', '')
}
//删除菜单
export function menuid(params) {
    return POST(`${BASE_URL}/evaluate/menu/` + params.id, params, 'DELETE', '')
}
//二维码-延长过期时间
export function qrcodeextendExpireTime(params) {
    return POST(`${BASE_URL}/evaluate/qrcode/extendExpireTime?groupId=` + params.groupId + "&expireTime=" + params.expireTime, params, 'post', '')
}
//分类
export function courseclassify() {
    return POST(`${BASE_URL}/evaluate/course/classify/list?parentId=0&groupId=1`, '', 'get', '')
}
//查询管理员列表
export function groupmanagergetList(params) {
    return POST(`${BASE_URL}/evaluate/group/manager/getList`, params, 'get', '')
}
//新增/编辑管理员
export function groupmanager(params) {
    return POST(`${BASE_URL}/evaluate/group/manager`, params, 'post', '')
}
//重置管理密码
export function groupmanagerid(params) {
    return POST(`${BASE_URL}/evaluate/group/manager/` + params.id, params, 'get', '')
}
// 通过bookid查询知识点
export function knowBook(params) {
    return POST(`${BASE_URL}/evaluate/knowledge/getBookKo`, params, 'post', '', '4')
}

// 章节知识点关联表-保存
export function chapterResknowSave(params) {
    return POST(`${BASE_URL}/evaluate/book/chapter-resknow/save`, params, 'post', '')
}
// 删除
export function deleteResknow(params) {
    return POST(`${BASE_URL}/evaluate/book/chapter-resknow/delete/` + params.id, {}, 'delete')
}
// 保存回复信息
export function saveFeedbackReply(params) {
    return POST(`${BASE_URL}/evaluate/problem/saveFeedbackReply`, params, 'post', '')
}
// 根据意见主键ID查询意见反馈信息（包含回复信息）
export function selectPrimaryKey(params) {
    return POST(`${BASE_URL}/evaluate/problem/selectFeedbackByPrimaryKey/` + params.id, '', 'get', '')
}
// 机构树列表
export function orgTree(params) {
    return POST(`${BASE_URL}/evaluate/org/tree`, params, 'get', '')
}
// 机构保存 编辑 
export function saveOrg(params) {
    return POST(`${BASE_URL}/evaluate/org`, params, 'post', '')
}
// 分页获取领导列表
export function leaderLsit(params) {
    return POST(`${BASE_URL}/evaluate/leader/v2/list`, params, 'get', '')
}
// 新增/修改领导,修改时,领导ID必传
export function addLeader(params) {
    return POST(`${BASE_URL}/evaluate/leader`, params, 'post', '')
}
// 根据ID获取领导详情
export function setLeader(params) {
    return POST(`${BASE_URL}/evaluate/leader/${params.id}`, '', 'get', '')
}
// 根据ID删除领导
export function deleteLeader(params) {
    return POST(`${BASE_URL}/evaluate/leader/${params.id}`, '', 'delete', '')
}
// 查询管理员列表
export function manageuserlist(params) {
    return POST(`${BASE_URL}/evaluate/manage/user/list`, params, 'get', '')
}
//新增/编辑管理员
export function manageusersave(params) {
    return POST(`${BASE_URL}/evaluate/manage/user/save`, params, 'post', '')
}
//激活/禁用账号
export function usercentermodifyStatus(params) {
    return POST(`${BASE_URL}/evaluate/usercenter/modifyStatus`, params, 'post', '', 4)
}
//一键添加数据源
export function batchCreate(params) {
    return POST(`${BASE_URL}/evaluate/nodes/sources/batchCreate`, params, 'post', '')
}
//分页查询学校详情（待完成）
export function queryCardPrintSchoolList(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/queryCardPrintSchoolList`, params, 'get', '')
}
//分页查询学校详情（待完成）
export function toBeCompleted(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/toBeCompleted`, params, 'get', '')
}
//分页查询订单列表
export function queryCardPrintOrderList(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/queryCardPrintOrderList`, params, 'get', '')
}
//统一登录订单查询  
export function querySchoolCardPrintOrderList(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/querySchoolCardPrintOrderList`, params, 'get', '')
}
//更新进度项状态
export function updateCardPrintItem(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/updateCardPrintItem?cardPrintItemId=` + params.cardPrintItemId + '&progressItemStatus=' + params.progressItemStatus, params, 'post', '')
}
//分页查询课程行为库（课程库）
export function selectCourseActionStore(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/selectCourseActionStore`, params, 'get', '')
}
//库里选择保存
export function insertCourseAction(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/insertCourseAction`, params, 'post', '')
}
//分页查询课程卡定制信息
export function selectCardPrintPredictList(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/selectCardPrintPredictList`, params, 'get', '')
}
//课程卡定制初始化
export function cardPrintCustomize(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/cardPrintCustomize`, params, 'get', '')
}
//保存课程卡定制
export function saveCardPrintCustomize(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/saveCardPrintCustomize`, params, 'post', '')
}
//导出课程行为
export const exportCardPrintPredictDetail = `${BASE_URL}/evaluate/cardPrint/exportCardPrintPredictDetail`
//根据课程卡预估ID获取课程卡预估详情
export function getCardPrintPredict(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/getCardPrintPredict`, params, 'get', '')
}
//查询学校收货地址
export function queryAddressList(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/queryAddressList`, params, 'get', '')
}
//保存收货地址
export function saveAddress(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/saveAddress`, params, 'post', '')
}
//删除收货地址
export function delAddress(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/delAddress/${params.id}`, params, 'DELETE', '')
}
//获取印厂厂商信息
export function getMangeUser(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/getMangeUser`, params, 'get', '')
}
//下单
export function placeAnOrder(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/placeAnOrder`, params, 'post', '')
}
//查看订单详情
export function getCardPrintOrderInfo(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/getCardPrintOrderInfo`, params, 'get', '')
}
//取消订单
export function cancelOrder(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/cancelOrder`, params, 'get', '')
}
//物料下载
export function materialDownload(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/materialDownload`, params, 'get', '')
}
//厂家发货
export function shipOrder(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/shipOrder`, params, 'post', '')
}
//厂家接单
export function factoryOrders(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/factoryOrders`, params, 'get', '')
}
//查看物流
export function checkLogistics(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/checkLogistics`, params, 'get', '')
}
//发布课程评价点
export function publishCourseEvaPoint(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/publishCourseEvaPoint`, params, 'get', '')
}
//获取课程卡基础参数配置
export function selectByConfigTypeCode(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/selectByConfigTypeCode`, params, 'get', '')
}
//保存课程卡基础参数配置
export function saveCardPrintConfig(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/saveCardPrintConfig`, params, 'post', '')
}
//厂家确认签收（厂家自送的物流才能签收）
export function factoryConfirmSign(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/factoryConfirmSign`, params, 'get', '')
}
//重置管理密码
export function resetPwds(params) {
    return POST(`${BASE_URL}/evaluate/manage/user/resetPwd`, params, 'POST', '')
}
//删除课程卡印制  
export function delCardPrintPredict(params) {
    return POST(`${BASE_URL}/evaluate/cardPrint/delCardPrintCustomize/` + params.id, {}, 'delete', '')
}
//课程卡定制完成  schoolCardPrint/doComplete
export function cardPrintComplete(params) {
    return POST(`${BASE_URL}/evaluate/schoolCardPrint/doComplete`, params, 'POST', '')
}


// WEBPACK FOOTER //
// ./src/api/observation.js